import { apiSlice } from "../../../../../app/apiSlice";
import {
  MenuFilho,
  MenuFilhoDTO,
  MenuFilhoList,
} from "../../../../../typesSite/menuFilho/MenuFilho";

import configSiteUrls from "../../../configs/configSiteUrls";

//usei o menuFilho como base

const endpointUrl = configSiteUrls.SITE_MENU_FILHO_EP;

function getMenuFilhoes({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: "GET",
  };
}

function addMenuFilho(obj: MenuFilhoDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: "POST",
    body: obj,
  };
}

function deleteMenuFilho({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: "DELETE",
  };
}
function getMenuFilho(id: string) {
  if (!id) {
    return {
      url: "",
      method: "",
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: "GET",
  };
}
/** */

export const menuFilhoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getMenuFilhos: query<MenuFilhoList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuFilhoes,
      providesTags: ["MenuFilho"],
    }),

    getMenuFilho: query<MenuFilho, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getMenuFilho,
      providesTags: ["MenuFilho"],
    }),
    addMenuFilho: mutation<void, MenuFilhoDTO>({
      query: addMenuFilho,
      invalidatesTags: ["MenuFilho"],
    }),
    deleteMenuFilho: mutation<void, { id: string }>({
      query: deleteMenuFilho,
      invalidatesTags: ["MenuFilho"],
    }),
  }),
});
export const {
  useGetMenuFilhosQuery,
  useGetMenuFilhoQuery,
  useAddMenuFilhoMutation,
  useDeleteMenuFilhoMutation,
} = menuFilhoApiSlice;
